<script setup>
import { useReferenceWorkspace } from "./referenceWorkspace";
import ReferenceResources from "@/components/ReferenceResources.vue";
const { reference, resourceAllocationEditing, setSectionRef } =
  useReferenceWorkspace();
</script>

<template>
  <section
    id="resources"
    :ref="(el) => setSectionRef('resources', el)"
    class="min-w-0 scroll-mt-24 2xl:col-span-12"
  >
    <div class="mb-3 flex flex-wrap items-center justify-between gap-3">
      <div>
        <div
          class="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400"
        >
          Resources
        </div>
        <h2 class="text-xl font-semibold text-slate-900 dark:text-slate-100">
          Resource allocation
        </h2>
      </div>
      <div
        class="inline-flex rounded-full border border-slate-200 bg-slate-100 p-1 dark:border-slate-700 dark:bg-slate-800"
        aria-label="Resource display mode"
      >
        <button
          type="button"
          class="rounded-full px-4 py-1.5 text-sm font-semibold transition"
          :class="
            !resourceAllocationEditing
              ? 'bg-white text-slate-900 shadow-sm dark:bg-slate-700 dark:text-white'
              : 'text-slate-500 hover:text-slate-800 dark:text-slate-300 dark:hover:text-white'
          "
          :aria-pressed="!resourceAllocationEditing"
          @click.prevent="resourceAllocationEditing = false"
        >
          View
        </button>
        <button
          type="button"
          class="rounded-full px-4 py-1.5 text-sm font-semibold transition"
          :class="
            resourceAllocationEditing
              ? 'bg-sky-600 text-white shadow-sm'
              : 'text-slate-500 hover:text-slate-800 dark:text-slate-300 dark:hover:text-white'
          "
          :aria-pressed="resourceAllocationEditing"
          @click.prevent="resourceAllocationEditing = true"
        >
          Edit
        </button>
      </div>
    </div>

    <ReferenceResources
      mode="resources"
      :reference="reference"
      :editable="resourceAllocationEditing"
    />
  </section>
</template>
